import { render, staticRenderFns } from "./SimpleTriggerList.vue?vue&type=template&id=44d38766&scoped=true"
import script from "./SimpleTriggerList.vue?vue&type=script&lang=js"
export * from "./SimpleTriggerList.vue?vue&type=script&lang=js"
import style0 from "./SimpleTriggerList.vue?vue&type=style&index=0&id=44d38766&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44d38766",
  null
  
)

export default component.exports